/*
  Similar products on the wellness PDP (sections/main-product-health.liquid).

  The section lists this product's own specific shelves (smallest first),
  then its brand shelf and its category shelf as top-ups. This fetches them
  as card fragments (templates/collection.vro-personalize.liquid — the same
  feed-product-card markup as every other rail, so add-to-cart and wishlist
  keep working), scores every candidate against this product, and fills the
  rail with the closest ones.

  Score, per candidate:
    +2 for each specific tag it shares with this product (Immunity,
       Ayurveda, Gut Care…; category, audience and housekeeping tags don't
       count — every Health & Nutrition product shares those)
    +1 for each of this product's stated concerns / intended effects that
       appears in the candidate's own structured fields
    +0.5 for each extra specific shelf it also sits on
  Ties keep in-stock first, then the shelf's best-selling order.

  Only candidates with a score go in. If fewer than four do, the row is
  topped up from the same brand, then the category's best-sellers — never
  from the whole store. With nothing at all, the rail stays hidden.
*/
(function () {
  'use strict';

  var GENERIC = [
    'health & nutrition', 'health and nutrition', 'sports & fitness', 'sports and fitness',
    'grooming & care', 'grooming and care', 'fashion & lifestyle', 'fashion and lifestyle',
    'vro luxe', 'vro kits', 'men', 'women', 'unisex', 'unisex adults', 'adults', 'adult',
    'kids', 'boys', 'girls', 'yes', 'no', 'new', 'new in', 'new arrivals', 'sale',
    'bestseller', 'best seller', 'trending', 'featured', 'spotlight bubbles'
  ];

  function splitList(s) {
    return String(s || '').split('|')
      .map(function (t) { return t.trim().toLowerCase(); })
      .filter(Boolean);
  }

  /* Merchandising tags — placements, badges, campaign groupings — say
     nothing about what the product is. */
  var GENERIC_PREFIX = ['placement', 'vro pick', 'hype', 'price drop', 'whats bugging', '3 bros', 'hyrox mode', 'health stack'];

  function isGeneric(tag, vendor) {
    if (!tag || tag.indexOf(':') > -1) return true;
    if (tag === vendor) return true;
    /* The store carries price-band tags split at their commas by an
       import ("000", "500", "₹1", "000–₹2", "Under ₹500"). They are not
       a kind of product, and "000 picks" was the chip they produced. A
       tag has to have a word in it to count. */
    if (!/[a-z]{2}/.test(tag) || tag.indexOf('₹') > -1) return true;
    for (var i = 0; i < GENERIC_PREFIX.length; i++) {
      if (tag.indexOf(GENERIC_PREFIX[i]) === 0) return true;
    }
    if (tag.indexOf('spotlight bubbles') === 0) return true;
    return GENERIC.indexOf(tag) > -1;
  }

  var SPARKLE =
    '<svg width="24" height="24" viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M12.2825 8.32959C13.1923 6.6654 13.6473 5.83331 13.9951 5.83331C14.343 5.83331 14.7979 6.6654 15.7078 8.32959C16.6442 10.0425 17.8957 11.3087 19.657 12.2733C21.3241 13.1863 22.1576 13.6427 22.1576 13.991C22.1576 14.3392 21.3235 14.7962 19.6554 15.7101C17.9443 16.6475 16.6794 17.9004 15.7157 19.6636C14.8037 21.3322 14.3477 22.1666 13.9998 22.1666C13.652 22.1666 13.1955 21.3318 12.2825 19.6618C11.3461 17.9489 10.0945 16.6827 8.33317 15.7181C6.66053 14.8021 5.82422 14.344 5.82422 13.9958C5.82422 13.6474 6.66053 13.1894 8.33317 12.2733C10.0945 11.3087 11.3461 10.0425 12.2825 8.32959Z" fill="#0080FF" stroke="#0080FF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function load(url) {
    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
  }

  function cardsOf(html) {
    if (!html) return [];
    var holder = document.createElement('div');
    holder.innerHTML = html;
    return Array.prototype.slice.call(holder.querySelectorAll('.feed-card'));
  }

  /* How many products the shelf holds in all, from the fragment's own
     count (paginate.items on collection.vro-personalize), so the chip's
     "from" is the shelf's real size, the way the fashion page counts. */
  function itemsOf(html) {
    if (!html) return 0;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var meta = holder.querySelector('[data-vro-pool]');
    return meta ? (parseInt(meta.getAttribute('data-vro-items'), 10) || 0) : 0;
  }

  function handleOf(card) {
    var h = card.getAttribute('data-vro-handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function rupees(paise) {
    var n = Math.round(paise / 100);
    try { return '₹' + n.toLocaleString('en-IN'); } catch (e) { return '₹' + n; }
  }

  function titleCase(s) {
    return String(s || '').replace(/(^|[\s&\-\/])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  function init(box) {
    if (box.getAttribute('data-vro-similar-ready')) return;
    box.setAttribute('data-vro-similar-ready', '1');

    var rail = box.querySelector('[data-vro-similar-rail]');
    if (!rail) return;

    var sources = (box.getAttribute('data-sources') || '').split('||').filter(Boolean);
    if (!sources.length) return;

    var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
    var exclude = box.getAttribute('data-exclude') || '';
    var vendor = (box.getAttribute('data-vendor') || '').trim();
    var myTags = splitList(box.getAttribute('data-tags')).filter(function (t) { return !isGeneric(t, vendor); });
    var myConcerns = splitList(box.getAttribute('data-concerns')).filter(function (c) { return c.length > 2; });

    var specific = sources.filter(function (u) { return u.indexOf('vro-fill=') === -1; });
    var brand = sources.filter(function (u) { return u.indexOf('vro-fill=brand') > -1; });
    var category = sources.filter(function (u) { return u.indexOf('vro-fill=category') > -1; });

    var pool = {};   // handle -> candidate
    var order = 0;
    /* The shelf the row is "from": the first of the product's own shelves
       that had cards, else the category shelf. Its real size is the total
       in the chip. */
    var totalSpecific = 0;
    var totalCategory = 0;
    /* The shelf the View All tile opens: the same one the total is read
       from, so "5 from 69" and the tile agree. */
    var titles = (box.getAttribute('data-source-titles') || '').split('||');
    var shelfSpecific = null;
    var shelfCategory = null;

    function add(cards, kind) {
      cards.forEach(function (card) {
        var h = handleOf(card);
        if (!h || h === exclude) return;
        var c = pool[h];
        if (!c) {
          c = pool[h] = { handle: h, card: card, order: order++, shelves: 0, kind: kind, score: 0, shared: [] };
        }
        if (kind === 'specific') {
          c.shelves++;
          if (c.kind !== 'specific') { c.kind = 'specific'; }
        }
      });
    }

    function score(c) {
      var tags = splitList(c.card.getAttribute('data-vro-tags'));
      var shared = myTags.filter(function (t) { return tags.indexOf(t) > -1; });
      var signals = ((c.card.getAttribute('data-vro-signals') || '') + ' | ' + (c.card.getAttribute('data-vro-benefits') || '')).toLowerCase();
      var concernHits = 0;
      myConcerns.forEach(function (p) { if (signals.indexOf(p) > -1) concernHits++; });
      c.shared = shared;
      c.score = shared.length * 2 + concernHits + Math.max(0, c.shelves - 1) * 0.5;
      c.soldout = c.card.getAttribute('data-vro-available') === 'false';
    }

    function rank(list) {
      return list.sort(function (a, b) {
        return (b.score - a.score) || ((a.soldout ? 1 : 0) - (b.soldout ? 1 : 0)) || (a.order - b.order);
      });
    }

    function loadAll(urls, kind) {
      return Promise.all(urls.map(load)).then(function (pages) {
        pages.forEach(function (html, i) {
          var cards = cardsOf(html);
          add(cards, kind);
          if (cards.length) {
            var n = itemsOf(html);
            var shelf = { url: urls[i], title: titles[sources.indexOf(urls[i])] || '' };
            if (kind === 'specific' && !totalSpecific) { totalSpecific = n; shelfSpecific = shelf; }
            if (kind === 'category' && !totalCategory) { totalCategory = n; shelfCategory = shelf; }
          }
        });
      });
    }

    /* The shared ranking (assets/vro-similar.js), from what the product
       is: its menu kind (Perfumes, Shavers & Trimmers, Ashwagandha), type
       and title, with this product's concerns as a tie-break. The scoring
       below stays as the way in only when that script or the product's
       config is missing. */
    var cfg = window.VroSimilar && window.VroSimilar.readConfig(box);
    if (cfg) {
      window.VroSimilar.pick(cfg, { limit: limit, concerns: myConcerns }).then(function (r) {
        if (!r.cards.length) return;
        rail.innerHTML = '';
        r.cards.forEach(function (card) { rail.appendChild(card); });
        var moreLabel = (box.getAttribute('data-more-label') || '').trim();
        if (moreLabel && r.url) {
          var more = document.createElement('a');
          more.className = 'pdp-more-like';
          more.href = r.url;
          more.innerHTML = SPARKLE;
          var words = document.createElement('span');
          words.textContent = moreLabel;
          var arrow = document.createElement('span');
          arrow.className = 'pdp-more-like-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '\u2192';
          words.appendChild(arrow);
          more.appendChild(words);
          rail.appendChild(more);
        }
        var sub = box.querySelector('[data-vro-similar-sub]');
        if (sub && r.label) {
          var tpl = sub.getAttribute('data-vro-similar-sub') || '';
          if (tpl.indexOf('[type]') > -1) sub.textContent = tpl.replace(/\[type\]/g, String(r.label).toLowerCase());
        }
        writeChip(box, r.cards.map(function (card) { return { card: card, shared: [] }; }), r.total, r.label);
        box.hidden = false;
        try {
          document.dispatchEvent(new CustomEvent('vro:cards:added', { detail: { container: rail }, bubbles: true }));
        } catch (e) { /* ignore */ }
      });
      return;
    }

    loadAll(specific, 'specific')
      .then(function () {
        var all = Object.keys(pool).map(function (h) { return pool[h]; });
        all.forEach(score);
        var matched = all.filter(function (c) { return c.score > 0; });
        if (matched.length >= Math.min(4, limit) || (!brand.length && !category.length)) return;
        // Short: look at the same brand and the category shelf as well.
        return loadAll(brand, 'brand').then(function () { return loadAll(category, 'category'); });
      })
      .then(function () {
        var all = Object.keys(pool).map(function (h) { return pool[h]; });
        all.forEach(score);

        var matched = rank(all.filter(function (c) { return c.score > 0; }));
        var picked = matched.slice(0, limit);

        if (picked.length < Math.min(4, limit)) {
          var kindRank = { brand: 0, category: 1, specific: 2 };
          var rest = all
            .filter(function (c) { return c.score <= 0 && c.kind !== 'specific'; })
            .sort(function (a, b) {
              return (kindRank[a.kind] - kindRank[b.kind]) || ((a.soldout ? 1 : 0) - (b.soldout ? 1 : 0)) || (a.order - b.order);
            });
          picked = picked.concat(rest.slice(0, limit - picked.length));
        }

        if (!picked.length) return;

        rail.innerHTML = '';
        picked.forEach(function (c) {
          c.card.removeAttribute('hidden');
          rail.appendChild(c.card);
        });

        /* The row closes on the "More like this" tile, as on the fashion
           PDP, opening the shelf the row was picked from (the product's
           own shelf, else the category shelf) — the one the count's
           total is read from. */
        var moreLabel = (box.getAttribute('data-more-label') || '').trim();
        var shelf = shelfSpecific || shelfCategory;
        if (moreLabel && shelf) {
          var more = document.createElement('a');
          more.className = 'pdp-more-like';
          more.href = shelf.url.split('?')[0];
          more.innerHTML = SPARKLE;
          var words = document.createElement('span');
          words.textContent = moreLabel;
          var arrow = document.createElement('span');
          arrow.className = 'pdp-more-like-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '\u2192';
          words.appendChild(arrow);
          more.appendChild(words);
          rail.appendChild(more);
        }

        writeChip(box, picked, Math.max(totalSpecific || totalCategory || 0, matched.length));
        box.hidden = false;
        try {
          document.dispatchEvent(new CustomEvent('vro:cards:added', { detail: { container: rail }, bubbles: true }));
        } catch (e) { /* ignore */ }
      });
  }

  /* The chip: written from the cards actually in the row, so it is true
     for this product — the tag most of them share with it, how many
     brands, and the price range. */
  function writeChip(box, picked, relevantTotal, kindLabel) {
    var brands = {};
    var brandCount = 0;
    var prices = [];
    var tagHits = {};
    picked.forEach(function (c) {
      var v = (c.card.getAttribute('data-vro-vendor') || '').trim();
      if (v && !brands[v]) { brands[v] = true; brandCount++; }
      var p = parseInt(c.card.getAttribute('data-vro-price'), 10);
      if (p > 0) prices.push(p);
      c.shared.forEach(function (t) { tagHits[t] = (tagHits[t] || 0) + 1; });
    });

    var topTag = '';
    var topHits = 0;
    Object.keys(tagHits).forEach(function (t) { if (tagHits[t] > topHits) { topHits = tagHits[t]; topTag = t; } });
    if (topHits < Math.ceil(picked.length / 2)) topTag = '';
    /* What the row is, from the shared ranking ("Perfumes"), rather than a
       tag the cards happen to share ("4–6 Hours", "Get Leaner"). */
    if (kindLabel) topTag = String(kindLabel).toLowerCase();

    var range = '';
    if (prices.length) {
      var lo = Math.min.apply(null, prices);
      var hi = Math.max.apply(null, prices);
      range = lo === hi ? rupees(lo) : rupees(lo) + '–' + rupees(hi);
    }
    var brandText = brandCount === 1 ? titleCase(Object.keys(brands)[0]) : brandCount + ' brands';

    var line;
    var tpl = (box.getAttribute('data-why-text') || '').trim();
    if (tpl) {
      line = tpl
        .replace(/\[type\]/g, topTag || 'picks')
        .replace(/\[brands\]/g, brandCount ? brandText : '')
        .replace(/\[price_range\]/g, range)
        .replace(/\[count\]/g, String(picked.length))
        .replace(/\s{2,}/g, ' ')
        .trim();
    } else if (topTag && kindLabel) {
      line = (brandCount === 1 ? 'More ' + topTag + ' from ' : titleCase(topTag) + ' from ') + brandText + (range ? ', ' + range : '');
    } else if (topTag) {
      line = titleCase(topTag) + ' picks from ' + brandText + (range ? ', ' + range : '');
    } else if (brandCount) {
      line = 'From ' + brandText + (range ? ', ' + range : '');
    } else {
      line = range;
    }

    var why = box.querySelector('[data-vro-similar-why]');
    var whyLine = box.querySelector('[data-vro-similar-why-line]');
    var countEl = box.querySelector('[data-vro-similar-count]');
    if (countEl) {
      var countTpl = box.getAttribute('data-count-text') || '[count] from [total]';
      countEl.textContent = countTpl
        .replace(/\[count\]/g, String(picked.length))
        .replace(/\[total\]/g, String(Math.max(relevantTotal, picked.length)));
    }
    if (why && whyLine && line) {
      whyLine.textContent = line;
      why.hidden = false;
    }
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vro-similar]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
